import React, { useEffect, useState } from "react";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import SelectDropdown from "src/Components/GlobalComponents/SelectDropdown";
import SimpleInput from "src/Components/SimpleInput";
import { IPharmaInventoryCreate, ITagsItems } from "src/types/GlobalInterfaces";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import { IPaginated } from "src/types/paginated";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
import { Option } from "react-multi-select-component";

interface IProps {
  state: IPharmaInventoryCreate;
  setState: (key: keyof IPharmaInventoryCreate, val: string | string[] | {[key : string] : any}[]) => void;
  tabChange: () => void;
}

interface ICategoryResponse {
  documents: ITagsItems[];
  paginated: IPaginated;
}

const InventoryTagsTab: React.FC<IProps> = ({ state, setState, tabChange }) => {
  const links = [
    {
      label: "You may also like",
      value: "You may also like",
    },
    {
      label: "Best Seller",
      value: "Best Seller",
    },
  ];
  return (
    <>
      <div className="products-tabs-content">
        {/* <SelectDropdown
          labelText="Link"
          options={links}
          isLabel={true}
          data={links.filter((v) => state.links?.includes(v?.value))}
          setData={(e) => setState("links", e.map((v) => v?.value) || [])}
          isMulti={true}
          checkboxShow
          placeholder={{ selectSomeItems: "Select Link" }}
        /> */}

        <CustomWebsiteDropdown
          options={links}
          data={links.filter((v) => state.links?.includes(v?.value))}
          setData={(e) => setState("links", e.map((v) => v?.value) || [])}
          labelText="Link"
          isRequired={true}
          dropdownMainId="link-dropdown"
          clearId="link-clear"
          optionId={(v : Option , index) => `link-option-${index + 1}`}
          isMulti
          loading={false}
        />
      </div>
      <div className="flex justify-end my-6">
        <PrimaryBtn
          ButtonText="Next"
          btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem" }}
          onPress={tabChange}
          id="next-btn"
        />
      </div>
    </>
  );
};

export default InventoryTagsTab;
